'use client';
import React, { useCallback } from 'react';
import { useFilter } from '@/src/hooks/use-filter';
import FilterFacetPanel from '../../pos/listing/filter-facet-panel';
import { FiltersType, generateQueryString } from '@/src/utils/helpers/query-string-generator-pos';
import { CustomRequestEvent, DataLayerService } from '@/lib/data-layer/data-layer';
import { useRouter } from 'next/navigation';
import { getBanks } from '@/src/app/pos/sorgulama/actions';
import { ResponseStoreFrontProductSearchFacet } from '@/src/interfaces/data-contracts';

const dataLayer = new DataLayerService();
const PosFilter = ({
  facets,
  sortingComponent,
}: {
  facets: ResponseStoreFrontProductSearchFacet[];
  sortingComponent?: React.ReactNode;
}) => {
  const router = useRouter();

  const handleFilterSubmit = (data: any) => {
    const typedData = data as FiltersType;
    const nonEmptyData = Object.keys(typedData).reduce((acc, key) => {
      // @ts-ignore
      if (Array.isArray(typedData[key]) && typedData[key].length) {
        // @ts-ignore
        acc[key] = Array.from(new Set(typedData[key]));
        // @ts-ignore
      } else if (typedData[key]) {
        // @ts-ignore
        acc[key] = typedData[key];
      }
      return acc;
    }, {} as any);

    const queryWithFilters = generateQueryString(nonEmptyData);
    const selectedBanks = nonEmptyData.Bank?.length || 0;
    const selectedPosTypes = nonEmptyData.PosType?.length || 0;

    if (selectedBanks === 1 && selectedPosTypes === 0) {
      goToBankSeoUrl();
    } else if (selectedPosTypes === 1 && selectedBanks === 0) {
      const posTypeMap = { Physical: 'yazar-kasa-pos', Virtual: 'sanal-pos', Digital: 'cep-pos', Mobile: 'mobil-pos' };
      // @ts-ignore
      router.push(posTypeMap[nonEmptyData.PosType[0]]);
    } else {
      router.push(`sorgulama?${queryWithFilters}`);
    }

    dataLayer.sendEvent(new CustomRequestEvent(queryWithFilters, 'Pos Ürünleri', 'Filtre', ''));
  };

  const { register, getValues, setValue, resetAndSubmit, selectedFilterCount, onSubmitHandler } = useFilter({
    facets,
    watchedFields: ['Bank', 'PosType'],
    onSubmit: handleFilterSubmit,
  });
  const goToBankSeoUrl = useCallback(async () => {
    try {
      const banks = await getBanks();
      const selectedBanks = Array.from(new Set(getValues().Bank));

      if (!selectedBanks || selectedBanks.length !== 1) {
        return;
      }

      const bankId = Number(selectedBanks[0]);
      const bank = banks.find((b) => b.id === bankId);

      if (!bank?.seoUrl) {
        console.error('Secili banka bulunamadi veya seoUrl yok.');
        return;
      }

      router.push(`/pos/${bank.seoUrl}`);
    } catch (error) {
      console.error('Error goToBankSeoUrl:', error);
    }
  }, [getValues, router]);

  return (
    <FilterFacetPanel
      sortingComponent={sortingComponent}
      // reset={reset}
      resetAndSubmit={resetAndSubmit}
      facets={facets}
      handleSubmit={onSubmitHandler}
      // watchedValues={watchedValues}
      register={register}
      getValues={getValues}
      setValue={setValue}
      selectedFilterCount={selectedFilterCount}
    />
  );
};

export default PosFilter;
